import { ApiService } from './ApiService';

export interface ExecutionLog {
  id: string;
  flowId: string;
  nodeId: string;
  userId: string;
  sessionId: string;
  message: string;
  errorStack?: string;
  isError: boolean;
  userName?: string;
  createdAt: string;
  updatedAt: string;
}

export class ExecutionLogsService extends ApiService {
  static pathName = '/executions_logs';

  static getExecutionLogs = (
    flowId: string,
    nodeId: string,
  ): Promise<ExecutionLog[]> => {
    return this.get(`${this.pathName}/nodes?flowId=${flowId}&nodeId=${nodeId}`);
  };
}
